import { useState } from 'react'

interface FormReturnHandlerProps {
  success: boolean
  message: string
  open: boolean
  onClose: () => void
}

export default function FormReturnHandler({
  success,
  message,
  open,
  onClose,
}: FormReturnHandlerProps) {
  const [display, setDisplay] = useState(open)

  const onClick = () => {
    setDisplay(false)
    onClose()
  }

  const colorClasses = success
    ? 'bg-[#E6FBEA] text-[#1AAF56]'
    : 'bg-[#FEE2E2] text-[#E80000]'
  return (
    <div
      className={`${colorClasses} absolute right-10 bottom-20 w-fit p-4 ${display ? 'block' : 'hidden'} text-lg`}
      onClick={onClick}
      onKeyUp={onClick}
      role="button"
      tabIndex={0}
    >
      {message}
    </div>
  )
}
